import React, { useState } from "react";
import { Link, useTheme } from "@mui/material";
import { useAlert } from "../../contexts/AlertContext";
import { useTranslation } from "react-i18next";
import LocalStorageUtil from "../../utils/localStorageUtil";
import { storageKeys } from "../../utils/constants";
import { VgmPdfGeneratorApi } from "../../utils/urlConst";
import apiService from "../../apiService/ApiService";
import { handleDownload } from "../../utils/commonMethods";

interface DocumentDownloadLinkProps {
  documentUrl: string;
  documentName: string;
  children: React.ReactNode;
  projectId: number | null;
}

const DocumentDownloadLink: React.FC<DocumentDownloadLinkProps> = ({
  documentUrl,
  documentName,
  children,
  projectId,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const { showAlert } = useAlert();

  const handleClick = () => {
    if (documentName === "VGM.pdf") {
      handleVGMPdfGenerator();
    } else {
      handleDownload(documentUrl, documentName, showAlert, t, setIsLoading);
    }
  };

  // VGM PDF Generate Api call
  const handleVGMPdfGenerator = async () => {
    try {
      setIsLoading(true);
      let userName = LocalStorageUtil.getItem(storageKeys.userName, "");

      let jsondata = JSON.stringify({
        id: projectId,
        username: userName,
        type: "app",
      });

      const responseJson: any | null = await apiService.get(
        VgmPdfGeneratorApi,
        jsondata
      );

      if (
        responseJson?.hasOwnProperty("status") &&
        responseJson?.status_code === 1
      ) {
        handleDownload(
          responseJson?.url,
          documentName,
          showAlert,
          t,
          setIsLoading
        );
      } else if (responseJson?.status_code === 0) {
        showAlert(t("common.PDF_Generation_failed"), "error");
      } else {
        showAlert(t("common.server_error"), "error");
      }
    } catch (error) {
      showAlert(t("common.server_error"), "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Link
      component="button"
      fontFamily={"Nunito Sans Regular700"}
      fontSize={"14px"}
      // onClick={documentName === "VGM.pdf" ? undefined : handleClick}
      onClick={handleClick}
      sx={{
        textDecoration: "underline",
        display: "inline-flex",
        alignItems: "center",
        "&:hover": {
          color: isLoading ? theme.palette.greyColors.dark : "primary.dark", // Change color on hover based on loading
        },
        color: isLoading ? theme.palette.greyColors.dark : "primary.dark",
      }}
      disabled={isLoading}
    >
      {children}
    </Link>
  );
};

export default DocumentDownloadLink;
